import React from 'react';
import { Ship, Sailboat, Anchor, Check } from 'lucide-react';
import { services } from '../../data/mock';

const ServicesSection = () => {
  const boatTypes = [
    {
      icon: Sailboat,
      title: "Voiliers",
      description: "Gagnez en vitesse grâce à une glisse parfaite."
    },
    {
      icon: Anchor,
      title: "Bateaux à moteur",
      description: "Manoeuvrabilité optimisée avec une carène impeccable."
    },
    {
      icon: Ship,
      title: "Yachts",
      description: "Optimisez la consommation de carburant et le confort de navigation."
    }
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Nos services
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Un service complet pour
            <span className="text-blue-600"> tous types de bateaux</span>
          </h2>
          <p className="text-slate-600 text-lg">
            Nous proposons un service d'entretien de coque régulier qui optimise les performances de votre embarcation.
          </p>
        </div>

        {/* Boat Types */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {boatTypes.map((type, idx) => {
            const IconComponent = type.icon;
            return (
              <div
                key={idx}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-slate-100"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">{type.title}</h3>
                <p className="text-slate-600">{type.description}</p>
              </div>
            );
          })}
        </div>

        {/* Services List */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">
            Ce que nous garantissons
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service) => (
              <div
                key={service.id}
                className="flex items-start gap-4 p-4 rounded-xl hover:bg-slate-50 transition-colors"
              >
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Check className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-1">{service.title}</h4>
                  <p className="text-sm text-slate-600">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
